/**
 * Auto-generated from `RATING_POLICIES`, `NPS_POLICY` and
 * `RATING_STATISTICS_VERSION` in
 * apps/python-api/canonical_analysis/rating_statistics.py.
 *
 * DO NOT EDIT - regenerate with (from apps/python-api):
 *   python -m scripts.export_reporting_rating_policy
 */

/** One unit's rating bands: favorable at or above, unfavorable at or below. */
export interface RatingBandPolicy {
  minimum: number
  maximum: number
  favorableMinimum: number
  unfavorableMaximum: number
  topBoxMinimum: number
}

export const RATING_STATISTICS_VERSION = "rating-statistics.v1"

/** The canonical rating policy per declared rating unit. */
export const RATING_POLICIES: Readonly<Record<string, RatingBandPolicy>> = {
  "binary_yes_no": { minimum: 0, maximum: 1, favorableMinimum: 1, unfavorableMaximum: 0, topBoxMinimum: 1 },
  "rating_0_10": { minimum: 0, maximum: 10, favorableMinimum: 6, unfavorableMaximum: 4, topBoxMinimum: 10 },
  "rating_0_100": { minimum: 0, maximum: 100, favorableMinimum: 70, unfavorableMaximum: 30, topBoxMinimum: 90 },
  "rating_1_10": { minimum: 1, maximum: 10, favorableMinimum: 8, unfavorableMaximum: 3, topBoxMinimum: 10 },
  "rating_1_5": { minimum: 1, maximum: 5, favorableMinimum: 4, unfavorableMaximum: 2, topBoxMinimum: 5 },
  "rating_1_7": { minimum: 1, maximum: 7, favorableMinimum: 6, unfavorableMaximum: 2, topBoxMinimum: 7 },
}

/** Recommendation scoring (metric kind nps_like on rating_0_10): promoters, detractors. */
export const NPS_POLICY: RatingBandPolicy = { minimum: 0, maximum: 10, favorableMinimum: 9, unfavorableMaximum: 6, topBoxMinimum: 10 }
